module.exports = __webpack_public_path__ + "static/media/graphy.f0fa8521.png";